import axios from 'axios';
import Token from '@/utils/Token';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if(error.response) {
            if (error.response.status === 401) {
                Token.remove();
                // this.$router.push({ name: 'login' });
                window.location.replace("/login?error=auth");
                return Promise.resolve({});
            } else if(error.response.status === 405) {
                error.message = "Você não tem permissão para executar esta operação.";
            }
        } 
        return Promise.reject(error);
    },
);
